import styled from 'styled-components';

export const ContentWrapper = styled.div`
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
    scrollbar-width: none;
    -ms-overflow-style: none;

    ::-webkit-scrollbar {
        display: none;
    }
`;

export const ContentRowWrapper = styled.div`
    margin-bottom: 2rem;
`;

export const ContentRowTitle = styled.div`
    color: white;
    margin: 0.5rem 0;
    font-size: 1.8rem;
    font-weight: 700;
    padding-left: 3rem;
`;

export const ContentRowScrollingWrapper = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    flex-shrink: 1;
    flex-grow: 1;
    padding-left: 3rem;
    padding-right: 3rem;
`;

export const ContentRowScrollingContent = styled.div`
    display: flex;
    flex-direction: row;
    padding-right: 3rem;
    margin-right: 3rem;
`;

export const PlaylistSection = styled.div`
    margin-bottom: 40px;
    scroll-margin-top: 20px;
`;

export const Title = styled.div`
    font-size: 2rem;
    font-weight: bolder;
    margin-bottom: 10px;
`;

export const Row = styled.div`
    min-width: 100%;
    display: flex;
    overflow-x: hidden;
    position: relative;
`;

export const Col = styled.div`
    width: 400px;
    margin: 10px;
    flex-shrink: 0;
`;

export const ThumbnailCard = styled.div<{$focused: boolean}>`
    background-color: #1e1e1e;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s;
    cursor: pointer;
    border: ${({$focused}) => ($focused ? '4px solid white' : '2px solid transparent')};

    &:hover {
        transform: translateY(-4px);
    }
`;

export const ThumbnailImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
`;

export const VideoTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    padding: 8px 12px;
    line-height: 1.4;
`;

export const VideoDate = styled.div`
    font-size: 12px;
    color: #aaa;
    padding: 0 12px 12px;
`;
